<template>
  <div class="foot fs-12 color-fff">
    <div style="position: relative;">
      <img :src="lgBg" alt="" class="lgbg">
      <div class="w1024">

        <div class="d-flex space-between text-left">
          <div style="position: relative;z-index: 5;">
            <h3>关于我们</h3>
            <ul class="color-9">
              <li><a href="#" @click="goAbout()"> 企业简介</a></li>
              <li><a href="#"> 组织架构</a></li>
              <li><a href="#"> 荣誉资质</a></li>
              <li><a href="#" @click="goTalent()"> 企业成员</a></li>
            </ul>
          </div>


          <div>
            <h3>新闻中心</h3>
            <ul class="color-9">
              <li><a href="#" @click="goNews()">道信动态</a>
              </li>
              <li><a href="#" @click="goNews()">媒体报道</a></li>

            </ul>
          </div>


          <div>
            <h3>企业文化</h3>
            <ul class="color-9">
              <li><a href="#">员工活动</a>

              </li>
              <li><a href="#">招聘信息</a></li>
              <li><a href="#">联系方式</a></li>

            </ul>
          </div>


          <div>
            <h3>道信产业</h3>
            <ul class="color-9">
              <li><a href="#"  @click.prevent="goToBrand('education')">教育领域</a></li>
              <li><a href="#" @click.prevent="goToBrand('agriculture')">现代农业</a></li>
              <li><a href="#"  @click.prevent="goToBrand('ai')">人工智能领域</a></li>
              <li><a href="#" @click.prevent="goToBrand('healthcare')">大健康领域</a></li>
            </ul>
          </div>
          <div style="width: 240px;">
            <h3>联系方式</h3>
            <ul class="color-fff">
              <li class="d-flex" style="flex-direction: row;"><img :src="mapfoot" alt=""
                  style="width: 13px;height: 16px;margin-top: 5px;margin-right: 10px;"> <span>地址 北京市海淀区西三环北路72号院A座16层1902</span>
              </li>
              

            </ul>
          </div>

          <div class="text-center">
            <img :src="ewm" alt="" style=" margin-top:40px;">
            <p class="color-fff">信道资本公众平台</p>
          </div>





        </div>
      </div>

      <div class="w100" style="border-top: 1px solid #034485;padding-top:20px;margin-top: 30px; padding-bottom: 30px;">


        <div class="d-flex w1024 space-between">
          <div>
            <img :src="footImg" alt="" style="width: 80px; ">
          </div>
          <div class="color-fff">
            Copyright © 2025 北京道信资产管理有限公司 版权所有 京ICP备2020087382号 基金业协会编码P1068159
          </div>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import footImgs from "@/images/logon.png"
import ewms from '@/images/ewm.png'
import mapfoots from '@/images/mapfoot.png'
import emailsfoots from '@/images/footeml.png'
import tel from '@/images/tel.png'
import lgBg from "@/images/bgft.png"
export default {
  name: 'IndxFoot',
  props: {
    msg: String
  },
  data() {
    return {
      lgBg: lgBg,
      footImg: footImgs,
      tel:tel,
      ewm: ewms,
      mapfoot: mapfoots,
      emailsfoot: emailsfoots
    }
  },
  methods: {
    goTalent() {
      this.$router.push('/talent');
    },
    goAbout() {
      this.$router.push('/about');
    },
    goNews() {
      this.$router.push('/news');
    },
    // goBrand() {
    //   this.$router.push('/brand');
    // },
    goToBrand(section) {
    // 跳转到品牌页面，并传递定位参数
    this.$router.push({
      path: '/brand',
      query: { section: section }
    });
  },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin-top: 40px;
  margin-bottom: 16px;
}

ul li {
  line-height: 2;
}

.foot {
  width: 100%;

  background-color: #004890;
}

.foot ul li a {
  color: #ffffff;
  text-decoration: none;
}

.foot ul li a:hover {
  color: #ffffff;
}

.lgbg {
  position: absolute;
  left: 250px;
  mix-blend-mode: multiply;
  top: 0;
  opacity: 0.03;
  z-index: 2;
  width: 195px;
  /* background: url(/src/images/bgft.png) no-repeat left top; */
}
</style>
